import React from 'react'
import { BlockWrapper, ChildrenBlock, defineBlock } from '@smartfire/js-block-engine'
import style from './style.module.scss'
import SubMenu from './sub-menu'
import { menuItemParams } from '../types'

type Props = {
    subMenu: menuItemParams[]
}

const Footer: React.FC<Props> = ({ subMenu }) => {
    return (
        <BlockWrapper.Footer className={style.footer}>
            <ChildrenBlock
                gutenbergEditorConfig={{
                    allowedBlocks: ['smartfire/footer---partners', 'smartfire/footer---menu'],
                    template: [['smartfire/footer---partners'], ['smartfire/footer---menu']],
                    templateLock: true,
                }}
                className={style.top}
            />
            <SubMenu subMenu={subMenu} />
        </BlockWrapper.Footer>
    )
}

export default defineBlock({
    Block: Footer,
    smartProps: {},
    setup: {
        title: 'Footer',
        category: 'widgets',
    },
})
